import Modal from '../Modal';
import {
  toastError,
  toastSuccess,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';
import TagList from '../TagList';
import TagForm from '../TagForm';
import { useTagAndSegment } from '../../contexts/tagAndSegment';
import { useModal } from '../../contexts/modal';
import BreadcrumbWrapper from '../BreadcrumbWrapper/index';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import ShowFor from '@Components/ShowFor';

const Tags = () => {
  const { handleCreateTag } = useTagAndSegment();
  const { openModal, closeModal } = useModal();

  const handleSubmitNewTag = async (data) => {
    const result = await handleCreateTag(data);

    if (result.success) {
      toastSuccess('Tag created successfully');
      closeModal();
    } else {
      toastError(result.error);
    }
  };

  return (
    <div>
      <BreadcrumbWrapper crumbArray={[{ path: '/tags', label: 'Tags' }]} />
      <div className="p-4">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="mb-4 text-2xl font-bold">Tags</h1>

          <ShowFor permissions={['TAGS_WRITE']}>
            <Button onClick={openModal}>Create tag</Button>
          </ShowFor>
        </div>

        <div className="pb-10">
          <TagList />
        </div>

        <Modal className={'max-w-xl'}>
          <h2 className="mb-4 text-lg font-bold">Create tag</h2>
          <TagForm onSubmitHandler={handleSubmitNewTag} buttonText="Create" />
        </Modal>
      </div>
    </div>
  );
};

export default Tags;
